import { render, staticRenderFns } from "./OderInfo.vue?vue&type=template&id=65f7dd4a&scoped=true&"
import script from "./OderInfo.vue?vue&type=script&lang=js&"
export * from "./OderInfo.vue?vue&type=script&lang=js&"
import style0 from "./OderInfo.vue?vue&type=style&index=0&id=65f7dd4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7dd4a",
  null
  
)

export default component.exports